import { oz } from '@weft/utils';
import { CurrencySchema } from '../../../primitives/currency-schema/currency-schema';

export const SlackInvoiceDataSchema = oz.object({
  customerName: oz.string(),
  invoiceDate: oz.string(),
  amountDue: oz.number(),
  dueDate: oz.string().optional(),
  invoiceId: oz.string(),
  currency: CurrencySchema,
});

export type SlackInvoiceData = oz.infer<typeof SlackInvoiceDataSchema>;